"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MiniBagWrapper = require("./MiniBagWrapper");
Object.keys(_MiniBagWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MiniBagWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MiniBagWrapper[key];
    }
  });
});
